import {Injectable} from '@angular/core';
import {Headers, Http, Response, ResponseContentType, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import {environment} from '../../../environments/environment';
import {Router} from '@angular/router';
import 'rxjs/add/operator/map';
import * as FileSaver from 'file-saver';

@Injectable()
export class ApiEvsService {
  private header: Headers;
  private endPoint: string;
  private endPointAdd: string;

  constructor(private http: Http, private router: Router) {
    let contentHeaders = new Headers();
    this.header = contentHeaders;
  }

  public setHeader(key: string, value: string): ApiEvsService {
    this.header.set(key, value);
    return this;
  }

  public setEndPoint(s: string) {
    this.endPoint = s;
  }

  login(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    return this.http.post(environment.api_evs + url, body, {headers: this.header})
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  get(url: string, options?: any): Observable<any> {
    let params = new URLSearchParams();
    if (typeof options === 'object') {
      for (var i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http.get(environment.api_evs + url, {headers: this.header, search: params})
      .map((res: any) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error)
      });
  }
  getServer(url: string, options?: any): Observable<any> {
    let params = new URLSearchParams();
    if (typeof options === 'object') {
      for (var i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http.get(environment.api_evs + url, {headers: this.header, search: params})
      .map((res: any) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error)
      });
  }

  getNoToken(url: string, options?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    let params = new URLSearchParams();
    if (typeof options === 'object') {
      for (var i in options) {
        params.set(i, options[i]);
      }
    }
    return this.http.get(environment.api_evs + url, {headers: this.header, search: params})
      .map((res: any) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error)
      });
  }

  getFullUrl(url_api: string, options?: any): Observable<any> {

    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http.get(url_api, {headers: this.header})
      .map((res: any) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error;
      });
  }

  getFromiCheck(url_api: string, options?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    let params = new URLSearchParams();
    if (typeof options === 'object') {
      for (var i in options) {
        params.set(i, options[i]);
      }
    }
    this.header.set('Content-Type', 'application/json');
    this.header.set('Authorization', 'Basic aWNoZWNrOmlZQUYmO2NCZSNHM2F+RDojaGVjaw==');
    return this.http.get(url_api, {headers: this.header, search: params})
      .map((res: any) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error)
      });
  }

  post(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http.post(environment.api_evs + url, body, {headers: this.header})
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {

        throw this.checkErr(error);
      });
  }

  postServer(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http.post(environment.api_evs + url, body, {headers: this.header})
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {

        throw this.checkErr(error);
      });
  }

  postFullUrl(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http.post(url, body, {headers: this.header})
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error;
      });
  }

  postNoToken(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    return this.http.post(environment.api_evs + url, body, {headers: this.header})
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  put(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http.put(environment.api_evs + url, body, {headers: this.header})
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => Observable.throw(this.checkErr(error) || 'Server error'));
  }

  putServer(url: string, body?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http.put(environment.api_evs + url, body, {headers: this.header})
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => Observable.throw(this.checkErr(error) || 'Server error'));
  }

  delete(url: string, options?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http.delete(environment.api_evs + url, {headers: this.header, search: options})
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => Observable.throw(this.checkErr(error) || 'Server error'));
  }

  deleteServer(url: string, options?: any): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http.delete(environment.api_evs + url, {headers: this.header, search: options})
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => Observable.throw(this.checkErr(error) || 'Server error'));
  }

  multiPost(url: string, data: {}): Observable<any> {
    this.header.set('Content-Type', 'application/json');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
    }
    return this.http.post(environment.api_evs + url, data, {headers: this.header})
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
  }

  all(data?: {}) {
    return this.get(this.endPoint, data);
  }

  find(id, data?: {}) {
    return this.get(this.endPoint + '/' + id, data);
  }

  add(data: {}) {
    return this.post(this.endPointAdd, data);
  }

  update(id, data: {}) {
    return this.put(this.endPoint + '/' + id, data);
  }

  remove(id, data?: {}) {
    return this.delete(this.endPoint + '/' + id, data);
  }

  check(res) {
    var response = res.json() ? res.json() : true;
    let status;
    if (response.hasOwnProperty('statusCode')) {
      status = response.statusCode;
    }
    if (response.hasOwnProperty('status')) {
      status = response.status;
    }

    if (status == 200 || status == 201) {
      if (status == 401) {
        this.router.navigate(['/page-401']);
        throw res;
      } else {
        return response;
      }
    } else if (status == 400) {
      throw res;
    } else if (status == 401) {
      this.router.navigate(['/page-401']);
      throw res;
    } else if (status == 403) {
      localStorage.removeItem('Access-Token');
      localStorage.removeItem('Access-Token-Icheck');
      this.router.navigate(['/login']);
    } else if (status == 406) {
      this.router.navigate(['/permission/error']);
      throw res;
    } else if (status == 204) {
      return true;
    } else {
      throw res;
    }
  }

  checkErr(err) {
    var errorRes = err.json();
    let status;
    if (errorRes.hasOwnProperty('statusCode')) {
      status = errorRes.statusCode;
    }
    if (errorRes.hasOwnProperty('status')) {
      status = errorRes.status;
    }
    if (errorRes.hasOwnProperty('data')) { // for api register of icheck
      if (errorRes.data.hasOwnProperty('status')) {
        status = errorRes.data.status;
      }
    }

    if (status == 200 || status == 201) {
      if (status == 401) {
        throw errorRes;
      }
      else if (errorRes.data)
        return errorRes.data;
      else
        return true;
    } else if (status == 400) {
      throw errorRes;
    } else if (status === 401) {
      // console.log(err);
      this.router.navigate(['/page-401']);
      throw errorRes;
    } else if (status == 403) {
      localStorage.removeItem('Access-Token');
      localStorage.removeItem('Access-Token-Icheck');
      this.router.navigate(['/login']);
    } else if (status == 404) {
      throw {message: 'Không có dữ liệu.'};
    } else if (status == 406) {
      this.router.navigate(['/permission/error']);
      throw errorRes;
    } else if (status == 204) {
      return true;
    } else {
      let mess_xxx = errorRes.message ? errorRes.message : 'Có lỗi xảy trong quá trình lấy thông tin. Vui lòng thử lại sau.';
      throw {message: mess_xxx};
    }
  }


  getexcel(url: string, name: string = '') {
    if (localStorage.getItem('Access-Token')) {
      this.header.set('Authorization', localStorage.getItem('Access-Token'));
      this.header.append('Content-Type', 'application/json');
      this.header.append('responseType', 'blob');
      this.header.append('Accept', 'application/octet-stream');
    }
    let name2 = name.replace(' ', '-');

    this.http.get(environment.api_evs + url, {headers: this.header, responseType: ResponseContentType.ArrayBuffer})
      .map(
        (res: any) => {
          return res;
        }
      ).subscribe(
      data => {
        console.log(typeof(data._body));
        let blob = new Blob([data._body], {
          type: 'application/zip'
        });
        FileSaver.saveAs(blob, 'Icheck-' + name2 + '.zip');
      },
      err => {
        console.error(err);
      }
    );
  }

  public loginFB(token_icheck) {
    let body = {
      'icheck_token': token_icheck,
      'ttl': 31556926
    };
    return this.http.post(environment.api_evs + '/login/token', body)
      .map((res: Response) => {
        return this.check(res);
      })
      .catch((error: any) => {
        throw this.checkErr(error);
      });
    // this.http.post(environment.api_evs + '/login/token', body).subscribe(
    //     res => {
    //         let body = JSON.parse(res['_body']);
    //         console.log('loginFB: ', body);
    //         if (body.status == 200) {
    //             // localStorage.setItem('Access-Token', body.data.token);// save token to local
    //             return body.data;
    //         } else {
    //             throw res;
    //         }
    //     },
    //     error => {
    //         throw error;
    //     });
  }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/ApiEvs.service.ts